import React from "react";
import { useTranslation } from "react-i18next";
import useForwarder from "../../hooks/useForwarder";
const ForwarderVersionCell = ({ forwarderId }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { data, isFetching } = useForwarder(forwarderId != null ? forwarderId : "");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, t("common.not_available"));
  }
  if (isFetching && !data) {
    return /* @__PURE__ */ React.createElement("span", null, forwarderId);
  }
  return /* @__PURE__ */ React.createElement("span", null, (data == null ? void 0 : data.version) || t("common.not_available"));
};
export default ForwarderVersionCell;
